import { CourseStepResponse } from './CourseStepResponse';
import { CompactUserResponse, UserId } from '../account';
import { PageQuery } from '../common';

export type CourseId = string;

export enum CourseType {
  active = 'active',
  archive = 'archive',
}
export enum CourseStatus {
  all = 'all',
  publish = 'published',
  unpublish = 'un-published',
}

export const courseTypes = [CourseType.active, CourseType.archive];
export const courseStatuses = [CourseStatus.all, CourseStatus.publish, CourseStatus.unpublish];

export interface CourseSearchParams extends PageQuery {
  userId?: UserId;
  search?: string;
  type?: CourseType;
  status?: CourseStatus;
  isCompleted?: boolean;
  isCompact?: boolean;
}

export interface CourseEnrollerResponse {
  id: CourseId;
  user: CompactUserResponse;
  isCompleted: boolean;
  progress: number;
  lastVisit?: number;
  completedAt?: number;
  version?: number;
}
export interface CourseResponse {
  id: CourseId;
  title: string;
  description: string;
  type: CourseType;
  status: CourseStatus;
  sections: CourseSectionResponse[];
  users: CourseEnrollerResponse[];
  my?: CourseEnrollerResponse;
  settings: CourseSettingsResponse;
  menuOrder: number;
}

export interface CourseSettingsResponse {
  completeMessage: string;
}

export type VeryCompactCourseResponse = Pick<CourseResponse, 'id' | 'title' | 'description'> & {
  isEnrolled: boolean;
};

export type CourseSectionId = number;
export interface CourseSectionResponse {
  id: CourseSectionId;
  name: string;
  menuOrder: number;
  steps: CourseStepResponse[];
}

export type CompactCourseResponse = CourseResponse;

export interface UserCourseCountResponse {
  userCourses: number;
  lineupCourses: number;
}
